<template>
  <v-card flat class="board-pp" ref="fullscreenRoot">
    <!-- ===================== KPI: MÁQUINAS ACTIVAS ===================== -->
    <div class="cp-kpi-grid pp-kpi-grid">
      <article class="cp-kpi-card cp-kpi-card--blue">
        <div class="cp-kpi-top">
          <div class="cp-kpi-top-main">
            <div class="cp-kpi-icon-pack cp-kpi-icon-pack--blue">
              <v-icon class="cp-kpi-icon-main">mdi-cog-outline</v-icon>
            </div>
            <p class="cp-kpi-title">{{ $t('Reports.ProductionPlan.kpi.activeMachines') }}</p>
          </div>
          <v-btn icon small class="cp-kpi-eye-btn" @click.stop="dialogActivas = true">
            <v-icon class="cp-kpi-eye-icon">mdi-eye-outline</v-icon>
          </v-btn>
        </div>
        <div class="cp-kpi-value-row">
          <p class="cp-kpi-value-main cp-kpi-value-main--blue">{{ maquinasActivas.activas }}</p>
          <p class="cp-kpi-value-secondary">/ {{ maquinasActivas.total }}</p>
        </div>
        <p class="cp-kpi-caption">{{ $t('Reports.ProductionPlan.kpi.withActivity') }}</p>
      </article>
    </div>

    <!-- ===================== TOOLBAR ===================== -->
    <div class="toolbar">
      <div class="seg-toggle">
        <button :class="{ act: vista === 'tiempoReal' }" @click="vista = 'tiempoReal'">
          {{ $t('Reports.ProductionPlan.toolbar.realTime') }}
        </button>
        <button :class="{ act: vista === 'teorico' }" @click="vista = 'teorico'">
          {{ $t('Reports.ProductionPlan.toolbar.theoretical') }}
        </button>
      </div>

      <span class="auto-refresh" :class="{ 'is-loading': cargando }" :title="$t('Reports.ProductionPlan.toolbar.autoRefreshTitle')">
        <v-icon small :class="{ 'spin': cargando }">mdi-autorenew</v-icon>
        {{ cargando ? $t('Reports.ProductionPlan.toolbar.updating') : $t('Reports.ProductionPlan.toolbar.updatesIn', { time: restanteTexto }) }}
      </span>

      <v-btn v-if="gamemode" small outlined color="orange darken-2" class="pp-fs-btn" @click="abrirConfig"
        :title="$t('Reports.ProductionPlan.settings.button')">
        <v-icon left small>mdi-cog-outline</v-icon>
        {{ $t('Reports.ProductionPlan.settings.button') }}
      </v-btn>

      <v-btn small outlined color="primary" class="pp-fs-btn" @click="toggleFullscreen"
        :title="esFullscreen ? $t('Reports.ProductionPlan.toolbar.exitFullscreen') : $t('Reports.ProductionPlan.toolbar.fullscreen')">
        <v-icon left small>{{ esFullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen' }}</v-icon>
        {{ esFullscreen ? $t('Reports.ProductionPlan.toolbar.exit') : $t('Reports.ProductionPlan.toolbar.fullscreen') }}
      </v-btn>
      <v-tooltip bottom color="blue-grey darken-4">
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" class="pp-language-control" v-on="on">
            <v-icon small color="primary" class="mr-2">mdi-translate</v-icon>
            <v-btn-toggle :value="currentLocale" mandatory dense class="pp-language-toggle" @change="setLocale">
              <v-btn small value="es" class="pp-language-btn"
                :class="{ 'pp-language-btn--active': currentLocale === 'es' }"
                :aria-label="$t('Reports.ProductionPlan.language.spanish')">
                ES
              </v-btn>
              <v-btn small value="en" class="pp-language-btn"
                :class="{ 'pp-language-btn--active': currentLocale === 'en' }"
                :aria-label="$t('Reports.ProductionPlan.language.english')">
                EN
              </v-btn>
            </v-btn-toggle>
          </div>
        </template>
        <span class="white--text">{{ $t('Reports.ProductionPlan.language.tooltip') }}</span>
      </v-tooltip>
    </div>

    <!-- ===================== FILTROS ===================== -->
    <div class="filtros">
      <div class="f-field">
        <label>{{ $t('Reports.ProductionPlan.filters.start') }}</label>
        <VueCtkDateTimePicker v-model="filtros.inicio" :disabled="cargando" :max-date="filtros.fin || undefined"
          format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm" first-day-of-week="1" noHeader overlay
          :locale="currentLocale" :label="$t('Reports.ProductionPlan.filters.date')"
          :button-now-translation="$t('Reports.ProductionPlan.chart.now')" />
      </div>
      <div class="f-field">
        <label>{{ $t('Reports.ProductionPlan.filters.end') }}</label>
        <VueCtkDateTimePicker v-model="filtros.fin" :disabled="cargando" :min-date="filtros.inicio || undefined"
          format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm" first-day-of-week="1" noHeader overlay
          :locale="currentLocale" :label="$t('Reports.ProductionPlan.filters.date')"
          :button-now-translation="$t('Reports.ProductionPlan.chart.now')" />
      </div>
      <div class="f-field f-grow">
        <label>{{ $t('Reports.ProductionPlan.filters.areas') }}</label>
        <v-autocomplete v-model="filtros.idsArea" :items="catAreas" multiple chips small-chips deletable-chips clearable
          dense outlined hide-details :disabled="cargando" :placeholder="$t('Reports.ProductionPlan.filters.all')" />
      </div>
      <div v-if="gamemode" class="f-field f-grow">
        <label>{{ $t('Reports.ProductionPlan.filters.instances') }}</label>
        <v-autocomplete v-model="filtros.idsInstancia" :items="catInstancias" multiple chips small-chips deletable-chips
          clearable dense outlined hide-details :disabled="cargando" :placeholder="$t('Reports.ProductionPlan.filters.all')" />
      </div>
      <div v-if="gamemode" class="f-field f-grow">
        <label>{{ $t('Reports.ProductionPlan.filters.workOrders') }}</label>
        <v-autocomplete v-model="filtros.idsTrabajoOrden" :items="catOrdenes" multiple chips small-chips deletable-chips
          clearable dense outlined hide-details :disabled="cargando" :placeholder="$t('Reports.ProductionPlan.filters.all')" />
      </div>
      <v-btn small color="primary" class="f-aplicar" :loading="cargando" @click="cargar">
        <v-icon left small>mdi-magnify</v-icon> {{ $t('Reports.ProductionPlan.filters.search') }}
      </v-btn>
    </div>

    <!-- ===================== LEYENDA ===================== -->
    <div class="legend">
      <span class="lg"><i class="i-plan" /> {{ $t('Reports.ProductionPlan.legend.plan') }}</span>
      <span v-for="(b, i) in bandasLeyenda" :key="i" class="lg">
        <i class="sw" :style="{ background: b.color }" /> {{ b.etiqueta || rangoBandaLeyenda(i) }}
      </span>
    </div>

    <!-- ===================== AVANCE TOTAL ===================== -->
    <div class="resumen">
      <span class="rs-titulo">{{ $t('Reports.ProductionPlan.summary.totalProgress') }}</span>
      <div class="rs-bar">
        <div class="rs-fill"
          :style="{ width: avance.porcentaje + '%', background: colorPorcentaje(avance.porcentaje) }" />
      </div>
      <span class="rs-pct" :style="{ color: colorPorcentaje(avance.porcentaje) }">
        {{ avance.porcentaje }}%
      </span>
      <span class="rs-sub">
        {{ fmtNum(avance.piezasOk) }} / {{ fmtNum(avance.piezasObjetivo) }} {{ $t('Reports.ProductionPlan.summary.pieces') }}
      </span>
    </div>

    <!-- ===================== GRÁFICA ===================== -->
    <div v-if="cargando && !tablero" class="cp-empty">{{ $t('Reports.ProductionPlan.empty.loadingBoard') }}</div>
    <div v-else-if="error" class="cp-empty">{{ $t('Reports.ProductionPlan.empty.boardError') }}</div>
    <div v-else-if="maquinasFiltradas.length === 0" class="cp-empty">{{ $t('Reports.ProductionPlan.empty.noMachines') }}</div>
    <div v-show="maquinasFiltradas.length > 0" ref="grafica" class="grafica-tablero"
      :style="{ height: altoGrafica + 'px' }" />

    <!-- Dialog de detalle de fragmento -->
    <v-dialog v-model="dialogFragmento" max-width="560">
      <v-card class="frag-card">
        <v-card-title class="frag-title">
          <i v-if="fragmento.esReal" class="frag-dot" :style="{ background: fragmento.colorHex }" />
          <span>{{ tipoLabel }}</span>
          <v-chip v-if="fragmento.esReal && fragmento.enCurso" color="primary" x-small class="ml-2">
            {{ $t('Reports.ProductionPlan.detail.inProgress') }}
          </v-chip>
          <v-spacer />
          <span v-if="fragmento.esReal" class="frag-banda" :style="{ color: fragmento.colorHex }">
            {{ bandaLabel }}
          </span>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-3">
          <!-- Identificación -->
          <div class="frag-sec">{{ $t('Reports.ProductionPlan.detail.identification') }}</div>
          <div class="frag-grid">
            <div class="frag-row"><span>{{ $t('Reports.ProductionPlan.detail.machineInstance') }}</span><b>{{ fragmento.maquina }}</b></div>
            <div class="frag-row"><span>{{ $t('Reports.ProductionPlan.detail.area') }}</span><b>{{ fragmento.area }}</b></div>
            <div class="frag-row"><span>{{ $t('Reports.ProductionPlan.detail.mold') }}</span><b>{{ fragmento.molde }}</b></div>
            <div class="frag-row"><span>ODT</span><b>{{ fragmento.clave }}</b></div>
          </div>

          <!-- Tiempos -->
          <div class="frag-sec">{{ $t('Reports.ProductionPlan.detail.times') }}</div>
          <div class="frag-grid">
            <div class="frag-row"><span>{{ $t('Reports.ProductionPlan.detail.start') }}</span><b>{{ fragmento.inicio }}</b></div>
            <div class="frag-row"><span>{{ $t('Reports.ProductionPlan.detail.end') }}{{ fragmento.enCurso ? ` (${$t('Reports.ProductionPlan.detail.projected')})` : '' }}</span><b>{{ fragmento.fin
                }}</b>
            </div>
            <div class="frag-row"><span>{{ fragmento.esReal ? $t('Reports.ProductionPlan.detail.realDuration') : $t('Reports.ProductionPlan.detail.duration') }}</span><b>{{
                fragmento.duracion }}</b></div>
            <div v-if="fragmento.esReal && fragmento.duracionTeorica" class="frag-row">
              <span>{{ $t('Reports.ProductionPlan.detail.theoreticalDuration') }}</span><b>{{ fragmento.duracionTeorica }}</b>
            </div>
            <div v-if="!fragmento.esReal && fragmento.holguraSeg > 0" class="frag-row">
              <span>{{ $t('Reports.ProductionPlan.detail.baseDuration') }}</span><b>{{ fragmento.duracionBase }}</b>
            </div>
            <div v-if="!fragmento.esReal && fragmento.holguraSeg > 0" class="frag-row">
              <span>{{ $t('Reports.ProductionPlan.detail.slack') }}</span><b>+{{ fragmento.holgura }}</b>
            </div>
            <div class="frag-row"><span>{{ $t('Reports.ProductionPlan.detail.scheduledTc') }}</span><b>{{ fragmento.tc ? fragmento.tc + ' s/pza' : '—' }}</b>
            </div>
          </div>

          <!-- Producción -->
          <div class="frag-sec">{{ $t('Reports.ProductionPlan.detail.production') }}</div>
          <div class="frag-grid">
            <div class="frag-row"><span>{{ $t('Reports.ProductionPlan.detail.target') }}</span><b>{{ fmtNum(fragmento.objetivo) }} {{ $t('Reports.ProductionPlan.summary.pieces') }}</b></div>
            <template v-if="fragmento.esReal">
              <div class="frag-row"><span>{{ $t('Reports.ProductionPlan.detail.producedOk') }}</span><b>{{ fmtNum(fragmento.ok) }} {{ $t('Reports.ProductionPlan.summary.pieces') }}</b></div>
              <div class="frag-row"><span>{{ $t('Reports.ProductionPlan.detail.notOk') }}</span><b>{{ fmtNum(fragmento.noOk) }} {{ $t('Reports.ProductionPlan.summary.pieces') }}</b></div>
              <div class="frag-row"><span>{{ $t('Reports.ProductionPlan.detail.missing') }}</span><b>{{ fmtNum(fragmento.faltantes) }} {{ $t('Reports.ProductionPlan.summary.pieces') }}</b></div>
              <div class="frag-row">
                <span>{{ $t('Reports.ProductionPlan.detail.compliance') }}</span>
                <b :style="{ color: fragmento.colorHex }">{{ fragmento.cumplimiento }}%</b>
              </div>
              <div class="frag-row"><span>{{ $t('Reports.ProductionPlan.detail.timeGap') }}</span><b>{{ desfaseTiempo }}</b></div>
              <div class="frag-row"><span>{{ $t('Reports.ProductionPlan.detail.percentGap') }}</span><b>{{ desfasePctTexto }}</b></div>
              <div class="frag-row frag-row--wide">
                <span>{{ $t('Reports.ProductionPlan.detail.range') }}</span>
                <b class="frag-rango" :style="{ color: fragmento.colorHex }">
                  <i class="frag-dot" :style="{ background: fragmento.colorHex, marginRight: '6px' }" />
                  {{ bandaLabel }}
                </b>
              </div>
            </template>
          </div>

          <!-- Barra de cumplimiento -->
          <div v-if="fragmento.esReal" class="frag-progress">
            <div class="frag-progress-bar">
              <div class="frag-progress-fill"
                :style="{ width: fragmento.cumplimientoBar + '%', background: fragmento.colorHex }" />
            </div>
            <span class="frag-progress-txt">{{ fmtNum(fragmento.ok) }} / {{ fmtNum(fragmento.objetivo) }}</span>
          </div>

          <!-- Detalle por operación (cada operación = una cavidad; corren en paralelo) -->
          <template v-if="fragmento.operaciones && fragmento.operaciones.length">
            <div class="frag-sec">{{ $t('Reports.ProductionPlan.detail.operations') }} · {{ fragmento.operaciones.length }} {{ $t('Reports.ProductionPlan.detail.cavities') }}</div>
            <table class="frag-ops">
              <thead>
                <tr>
                  <th>{{ $t('Reports.ProductionPlan.detail.articleCode') }}</th>
                  <th class="num">TC</th>
                  <th class="num">{{ $t('Reports.ProductionPlan.detail.scheduled') }}</th>
                  <template v-if="fragmento.esReal">
                    <th class="num">{{ $t('Reports.ProductionPlan.detail.done') }}</th>
                    <th class="num">OK</th>
                    <th class="num">{{ $t('Reports.ProductionPlan.detail.notOk') }}</th>
                  </template>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(op, i) in fragmento.operaciones" :key="op.idOperacion || i">
                  <td>{{ op.codigo || '—' }}</td>
                  <td class="num">{{ op.tc ? op.tc + ' s' : '—' }}</td>
                  <td class="num">{{ fmtNum(op.esperadas) }}</td>
                  <template v-if="fragmento.esReal">
                    <td class="num">{{ fmtNum(op.totales) }}</td>
                    <td class="num">{{ fmtNum(op.ok) }}</td>
                    <td class="num">{{ fmtNum(op.noOk) }}</td>
                  </template>
                </tr>
              </tbody>
            </table>
          </template>
        </v-card-text>
        <v-card-actions class="frag-actions">
          <v-btn v-if="fragmento.noIniciada" text color="error" @click="abrirCambioInstancia">
            <v-icon left small>mdi-swap-horizontal</v-icon>{{ $t('Reports.ProductionPlan.detail.changeInstance') }}
          </v-btn>
          <v-btn v-if="gamemode && fragmento.idTrabajoOrden && fragmento.operaciones && fragmento.operaciones.length"
            text color="primary" @click="abrirActualizarTc">
            <v-icon left small>mdi-timer-cog-outline</v-icon>{{ $t('Reports.ProductionPlan.detail.updateTc') }}
          </v-btn>
          <v-btn v-if="gamemode && fragmento.idTrabajoOrden" text color="error" @click="abrirFinalizarOdt">
            <v-icon left small>mdi-flag-checkered</v-icon>{{ $t('Reports.ProductionPlan.detail.finishOdt') }}
          </v-btn>
          <v-spacer />
          <v-btn text color="primary" @click="dialogFragmento = false">{{ $t('Reports.ProductionPlan.detail.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog: cambiar instancia (molde + instancia destino) de una ODT no iniciada -->
    <v-dialog v-model="dialogCambio" max-width="520" persistent>
      <v-card class="frag-card">
        <v-card-title class="frag-title">
          <v-icon left color="primary">mdi-swap-horizontal</v-icon>
          <span>{{ $t('Reports.ProductionPlan.changeInstance.title') }} · ODT {{ fragmento.clave }}</span>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-3">
          <div v-if="cambioCargando" class="cp-empty" style="padding:18px 0">{{ $t('Reports.ProductionPlan.empty.loadingDestinations') }}</div>
          <template v-else>
            <div v-if="cambioError" class="cambio-error">{{ cambioError }}</div>
            <div v-if="!destinos.length" class="cp-empty" style="padding:18px 0">
              {{ $t('Reports.ProductionPlan.empty.noDestinations') }}
            </div>
            <template v-else>
              <label class="cambio-lbl">{{ $t('Reports.ProductionPlan.changeInstance.targetMold') }}</label>
              <v-select v-model="destinoMoldeSel" :items="opcionesMolde" item-text="text" item-value="value" dense
                outlined hide-details :placeholder="$t('Reports.ProductionPlan.changeInstance.selectMold')" @change="destinoInstanciaSel = null" />
              <label class="cambio-lbl">{{ $t('Reports.ProductionPlan.changeInstance.targetInstance') }}</label>
              <v-select v-model="destinoInstanciaSel" :items="opcionesInstancia" item-text="text" item-value="value"
                dense outlined hide-details :disabled="!destinoMoldeSel"
                :no-data-text="destinoMoldeSel ? $t('Reports.ProductionPlan.changeInstance.noInstances') : $t('Reports.ProductionPlan.changeInstance.chooseMoldFirst')"
                :placeholder="$t('Reports.ProductionPlan.changeInstance.selectInstance')" />
            </template>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogCambio = false" :disabled="cambioGuardando" color="success">{{ $t('Reports.ProductionPlan.changeInstance.cancel') }}</v-btn>
          <v-btn color="primary" :loading="cambioGuardando" :disabled="!destinoMoldeSel || !destinoInstanciaSel"
            @click="confirmarCambioInstancia">{{ $t('Reports.ProductionPlan.changeInstance.moveOdt') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog: finalizar (terminar anticipadamente) una ODT — solo gamemode -->
    <v-dialog v-model="dialogFinalizar" max-width="480" persistent>
      <v-card class="frag-card">
        <v-card-title class="frag-title">
          <v-icon left color="error">mdi-flag-checkered</v-icon>
          <span>{{ $t('Reports.ProductionPlan.finish.title') }} {{ fragmento.clave }}</span>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-3">
          <div v-if="finalizarError" class="cambio-error">{{ finalizarError }}</div>
          <p class="mb-0">
            {{ $t('Reports.ProductionPlan.finish.messageStart') }} <b>{{ fragmento.clave }}</b>
            ({{ fragmento.articulo }}). {{ $t('Reports.ProductionPlan.finish.messageEnd') }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogFinalizar = false" :disabled="finalizarGuardando" color="success">{{ $t('Reports.ProductionPlan.finish.cancel') }}</v-btn>
          <v-btn color="error" :loading="finalizarGuardando" @click="confirmarFinalizarOdt">{{ $t('Reports.ProductionPlan.finish.confirm') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog: actualizar el TC por operación de la ODT — solo gamemode -->
    <v-dialog v-model="dialogTc" max-width="560" persistent>
      <v-card class="frag-card">
        <v-card-title class="frag-title">
          <v-icon left color="primary">mdi-timer-cog-outline</v-icon>
          <span>{{ $t('Reports.ProductionPlan.updateTc.title') }} {{ fragmento.clave }}</span>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-3">
          <div v-if="tcError" class="cambio-error">{{ tcError }}</div>
          <p class="mb-2 mt-0" style="color:#6b7682;font-size:12px">{{ $t('Reports.ProductionPlan.updateTc.help') }}</p>
          <table class="frag-ops">
            <thead>
              <tr>
                <th>{{ $t('Reports.ProductionPlan.detail.articleCode') }}</th>
                <th class="num">{{ $t('Reports.ProductionPlan.updateTc.currentTc') }}</th>
                <th class="num">{{ $t('Reports.ProductionPlan.updateTc.newTc') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(op, i) in tcOperaciones" :key="op.idOperacion || i">
                <td>{{ op.codigo || '—' }}</td>
                <td class="num">{{ op.tcActual ? op.tcActual + ' s' : '—' }}</td>
                <td class="num">
                  <v-text-field v-model.number="op.tc" type="number" min="1" dense outlined hide-details
                    suffix="s" style="max-width:120px;margin-left:auto" />
                </td>
              </tr>
            </tbody>
          </table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogTc = false" :disabled="tcGuardando" color="success">{{ $t('Reports.ProductionPlan.updateTc.cancel') }}</v-btn>
          <v-btn color="primary" :loading="tcGuardando" :disabled="!tcValido" @click="confirmarActualizarTc">{{ $t('Reports.ProductionPlan.updateTc.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog: máquinas con actividad -->
    <v-dialog v-model="dialogActivas" max-width="460">
      <v-card class="frag-card">
        <v-card-title class="frag-title">
          <v-icon left color="primary">mdi-cog-outline</v-icon>
          <span>{{ $t('Reports.ProductionPlan.activeDialog.title') }}</span>
          <v-spacer />
          <span class="frag-banda" style="color:#2563d6">
            {{ maquinasActivas.activas }} / {{ maquinasActivas.total }}
          </span>
        </v-card-title>
        <v-divider />
        <v-tabs v-model="tabActivas" grow color="primary">
          <v-tab>{{ $t('Reports.ProductionPlan.activeDialog.tabActive') }} ({{ maquinasActivas.activas }})</v-tab>
          <v-tab>{{ $t('Reports.ProductionPlan.activeDialog.tabExpected') }} ({{ maquinasActivas.total }})</v-tab>
        </v-tabs>
        <v-divider />
        <v-card-text class="pt-3">
          <v-tabs-items v-model="tabActivas">
            <!-- Activas: máquinas que reportan actividad reciente -->
            <v-tab-item>
              <div v-if="instanciasActivas.length === 0" class="cp-empty" style="padding:18px 0">
                {{ $t('Reports.ProductionPlan.empty.noActiveMachines') }}
              </div>
              <div v-for="(it, i) in instanciasActivas" :key="'act-' + i" class="frag-row">
                <span>{{ it.maquina }}</span><b>{{ it.detalle }}</b>
              </div>
            </v-tab-item>
            <!-- Esperadas: máquinas cuyo plan teórico cruza la línea de "ahora" -->
            <v-tab-item>
              <div v-if="maquinasEsperadas.length === 0" class="cp-empty" style="padding:18px 0">
                {{ $t('Reports.ProductionPlan.empty.noExpectedMachines') }}
              </div>
              <div v-for="(it, i) in maquinasEsperadas" :key="'esp-' + i" class="frag-row">
                <span>{{ it.maquina }}</span><b>{{ it.detalle }}</b>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="primary" @click="dialogActivas = false">{{ $t('Reports.ProductionPlan.detail.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog: configuración del reporte (holgura + bandas de color) — solo gamemode -->
    <v-dialog v-model="dialogConfig" max-width="600" persistent>
      <v-card class="frag-card">
        <v-card-title class="frag-title">
          <v-icon left color="orange darken-2">mdi-cog-outline</v-icon>
          <span>{{ $t('Reports.ProductionPlan.settings.title') }}</span>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-3">
          <label class="cambio-lbl">{{ $t('Reports.ProductionPlan.settings.slackPercent') }}</label>
          <v-text-field v-model.number="configReporte.porcentajeHolgura" type="number" min="0" max="100" step="1"
            dense outlined hide-details suffix="%" style="max-width:160px" />
          <p class="mt-2 mb-0" style="color:#6b7682;font-size:12px">
            {{ $t('Reports.ProductionPlan.settings.slackPercentHelp') }}
          </p>

          <v-divider class="my-4" />
          <label class="cambio-lbl">Actualización automática</label>
          <v-text-field v-model.number="configReporte.intervaloSeg" type="number" :min="10" :max="3600" step="10"
            dense outlined hide-details suffix="seg" style="max-width:160px" />
          <p class="mt-2 mb-0" style="color:#6b7682;font-size:12px">
            Cada cuántos segundos se recarga el reporte automáticamente (entre 10 y 3600). Por defecto 300 (5 min).
          </p>

          <v-divider class="my-4" />
          <label class="cambio-lbl">Bandas de color por desfase</label>
          <p class="mt-0 mb-3" style="color:#6b7682;font-size:12px">
            Cada banda pinta las ODT según su % de desfase. Toca el cuadro de color para cambiarlo;
            el límite inferior se calcula solo y la última banda cubre todo lo que supere su límite.
          </p>

          <div class="bandas-cards">
            <div v-for="(b, i) in configReporte.bandasDesfase" :key="i" class="banda-card">
              <div class="banda-card-top">
                <v-menu :close-on-content-click="false" offset-y>
                  <template #activator="{ on, attrs }">
                    <button type="button" class="banda-swatch" :style="{ background: b.color }"
                      v-bind="attrs" v-on="on" :title="b.color" />
                  </template>
                  <v-color-picker v-model="b.color" mode="hexa" hide-mode-switch flat />
                </v-menu>
                <span class="banda-rango-txt">{{ bandaRangoTexto(i) }}</span>
                <v-spacer />
                <v-btn icon small :disabled="configReporte.bandasDesfase.length <= 1" @click="quitarBanda(i)">
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </div>
              <div class="banda-card-body">
                <div class="banda-field banda-field--grow">
                  <label>Nombre</label>
                  <v-text-field v-model="b.etiqueta" dense outlined hide-details
                    placeholder="Nombre de la banda" />
                </div>
                <div v-if="i < configReporte.bandasDesfase.length - 1" class="banda-field">
                  <label>Cambia a los</label>
                  <v-text-field v-model.number="b.hasta" type="number" min="0" step="1" dense outlined
                    hide-details suffix="%" class="banda-hasta-input" />
                </div>
                <div v-else class="banda-ultima">
                  Última banda · cubre todo lo que supere {{ bandaDesde(i) }}%
                </div>
              </div>
            </div>
          </div>

          <v-btn text small color="primary" class="mt-2" @click="agregarBanda">
            <v-icon left small>mdi-plus</v-icon> Agregar banda
          </v-btn>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="primary" :loading="configGuardando" @click="reestablecerConfig">
            {{ $t('Reports.ProductionPlan.settings.reset') }}
          </v-btn>
          <v-spacer />
          <v-btn text color="success" :disabled="configGuardando" @click="cerrarConfig">
            {{ $t('Reports.ProductionPlan.settings.cancel') }}
          </v-btn>
          <v-btn color="primary" :loading="configGuardando" @click="guardarConfig">
            {{ $t('Reports.ProductionPlan.settings.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import * as echarts from 'echarts'
import axios from 'axios'

// Bandas de color por desfase de tiempo (3 por defecto): verde 0–10%, amarillo 10–15%,
// rojo >15%. La última banda (hasta: null) es el catch-all. Debe coincidir con BandasDesfaseDefault
// del backend. Cada banda: { hasta: % límite superior inclusivo (null = "y más"), color hex, etiqueta }.
const getBandasDesfaseDefault = () => ([
  { hasta: 10, color: '#63b46a', etiqueta: '0%–10% (en meta)' },
  { hasta: 15, color: '#f0ac22', etiqueta: '10%–15% desfase' },
  { hasta: null, color: '#d64545', etiqueta: '>15% desfase' },
])

// Configuración persistida del reporte (vía ReportesConfig, código r100): porcentaje de holgura
// (default 85%, = FactorHolguraTeorica del backend) y las bandas de color por desfase.
const getDefaultConfigReporte = () => ({
  porcentajeHolgura: 85,
  bandasDesfase: getBandasDesfaseDefault(),
  // Intervalo de auto-actualización en segundos (default 5 min).
  intervaloSeg: 300,
})

// Límites del intervalo de auto-actualización (segundos).
const INTERVALO_MIN_SEG = 10
const INTERVALO_MAX_SEG = 3600

const COLOR = {
  planFill: '#dcf0d6',
  planBorde: '#7cbd74',
  planTexto: '#2f6e2b',
  azul: '#2563d6',
  finJornada: '#1f78d1',
  ahora: '#c0392b',
}

const BANDA_COLOR = {
  verde: '#63b46a',
  amarillo: '#f0ac22',
  naranja: '#e67e22',
  rojo: '#d64545',
}

const DIAS = {
  es: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
  en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
}
const MESES = {
  es: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
  en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
}

// Lee una propiedad aceptando camelCase o PascalCase.
const prop = (obj, camel) => {
  if (!obj) return undefined
  if (obj[camel] !== undefined) return obj[camel]
  const pascal = camel.charAt(0).toUpperCase() + camel.slice(1)
  return obj[pascal]
}

const toMs = (iso) => {
  if (!iso) return NaN
  const t = new Date(iso).getTime()
  return Number.isNaN(t) ? NaN : t
}

const colorBanda = (ok, objetivo, colorBackend) => {
  // El backend ahora manda el color hex ya resuelto (banda de desfase configurable).
  if (typeof colorBackend === 'string' && colorBackend.charAt(0) === '#') return colorBackend
  if (colorBackend && BANDA_COLOR[colorBackend]) return BANDA_COLOR[colorBackend]
  if (!objetivo || objetivo <= 0) return BANDA_COLOR.verde
  const falt = Math.max(0, objetivo - ok)
  const pct = (falt * 100) / objetivo
  if (pct <= 1) return BANDA_COLOR.verde
  if (pct <= 10) return BANDA_COLOR.amarillo
  if (pct <= 15) return BANDA_COLOR.naranja
  return BANDA_COLOR.rojo
}

const fmtNum = (n) => Number(n || 0).toLocaleString('es-MX', { maximumFractionDigits: 0 })

const fmtHoras = (seg) => {
  const h = Math.round(Number(seg || 0) / 3600)
  return `${h} h`
}

const fmtFechaHora = (ms, locale = 'es') => {
  const d = new Date(ms)
  const p = (n) => String(n).padStart(2, '0')
  const dias = DIAS[locale] || DIAS.es
  const meses = MESES[locale] || MESES.es
  return `${dias[d.getDay()]} ${d.getDate()} ${meses[d.getMonth()]} ${p(d.getHours())}:${p(d.getMinutes())}`
}

const fmtDuracion = (seg) => {
  const s = Math.max(0, Math.round(Number(seg) || 0))
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  if (h > 0) return `${h} h ${m} min`
  if (m > 0) return `${m} min`
  return `${s} s`
}

const bandaTexto = (ok, objetivo, colorBackend) => {
  const map = { verde: 'En meta', amarillo: '1%–10% desfase', naranja: '10%–15% desfase', rojo: '>15% desfase' }
  if (colorBackend && map[colorBackend]) return map[colorBackend]
  if (!objetivo || objetivo <= 0) return 'En meta'
  const pct = (Math.max(0, objetivo - ok) * 100) / objetivo
  if (pct <= 1) return 'En meta'
  if (pct <= 10) return '1%–10% desfase'
  if (pct <= 15) return '10%–15% desfase'
  return '>15% desfase'
}

// Igual que bandaTexto pero devuelve la CLAVE de la banda ('verde' | 'amarillo' |
// 'naranja' | 'rojo') para resolver el texto con i18n en el template (reactivo al idioma).
const bandaKey = (ok, objetivo, colorBackend) => {
  const KEYS = ['verde', 'amarillo', 'naranja', 'rojo']
  if (colorBackend && KEYS.includes(colorBackend)) return colorBackend
  if (!objetivo || objetivo <= 0) return 'verde'
  const pct = (Math.max(0, objetivo - ok) * 100) / objetivo
  if (pct <= 1) return 'verde'
  if (pct <= 10) return 'amarillo'
  if (pct <= 15) return 'naranja'
  return 'rojo'
}

export default {
  name: 'ReportePlanDeProduccionV4',

  props: {
    active: { type: Boolean, default: false },
  },

  data() {
    return {
      chart: null,
      resizeHandler: null,
      cargando: false,
      error: false,
      tablero: null,
      // Máquinas en producción según /ReportesMoldes/MaquinasActivas (tokens físicos
      // activos sin paros abiertos). Alimenta el KPI azul "Máquinas activas".
      maquinasActivasApi: [],
      vista: 'tiempoReal',
      filtros: { inicio: '', fin: '', idsArea: [], idsTrabajoOrden: [], idsInstancia: [] },
      dialogFragmento: false,
      dialogActivas: false,
      // Pestaña activa del diálogo de máquinas: 0 = activas, 1 = esperadas.
      tabActivas: 0,
      // Cambio de instancia (molde + instancia destino) para ODTs no iniciadas.
      dialogCambio: false,
      cambioCargando: false,
      cambioGuardando: false,
      cambioError: '',
      destinos: [],
      destinoMoldeSel: null,
      destinoInstanciaSel: null,
      // Finalizar (terminar anticipadamente) una ODT — solo gamemode.
      dialogFinalizar: false,
      finalizarGuardando: false,
      finalizarError: '',
      // Actualizar el TC por operación de la ODT — solo gamemode.
      dialogTc: false,
      tcGuardando: false,
      tcError: '',
      tcOperaciones: [],
      esFullscreen: false,
      fsHandler: null,
      fragmento: {},
      // Configuración del reporte (porcentaje de holgura) — solo gamemode.
      codigoReporte: 'r100',
      configReporte: getDefaultConfigReporte(),
      dialogConfig: false,
      configGuardando: false,
      // Auto-actualización: la primera carga usa la semana en curso; a partir de
      // ahí cada recarga (auto o manual) consulta con los filtros actuales.
      // El intervalo es configurable (configReporte.intervaloSeg).
      restante: 300,
      timerTick: null,
    }
  },

  computed: {
    gamemode() {
      return localStorage.getItem("gamemode") === "true";
    },

    // Intervalo de auto-actualización vigente (segundos), tomado de la config.
    intervaloSeg() {
      const n = Number(this.configReporte && this.configReporte.intervaloSeg)
      return Number.isFinite(n) && n > 0 ? n : 300
    },

    currentLocale() {
      return this.$i18n.locale
    },

    maquinas() {
      return (this.tablero && (prop(this.tablero, 'maquinas') || [])) || []
    },

    maquinasFiltradas() {
      return this.maquinas
    },

    catAreas() {
      return this.catalogoItems('areas')
    },

    catInstancias() {
      return this.catalogoItems('instancias')
    },

    catOrdenes() {
      return this.catalogoItems('ordenesTrabajo')
    },

    avance() {
      const a = (this.tablero && prop(this.tablero, 'avance')) || {}
      return {
        porcentaje: Number(prop(a, 'porcentaje') || 0),
        piezasOk: Number(prop(a, 'piezasOk') || 0),
        piezasObjetivo: Number(prop(a, 'piezasObjetivo') || 0),
      }
    },

    // Bandas para la leyenda: las que aplicó el backend (tablero.bandasDesfase); si no llegan,
    // las de la config local o las default.
    bandasLeyenda() {
      const delTablero = prop(this.tablero, 'bandasDesfase')
      const bandas = Array.isArray(delTablero) && delTablero.length
        ? delTablero
        : ((this.configReporte && this.configReporte.bandasDesfase) || getBandasDesfaseDefault())
      return bandas.map((b) => ({
        color: prop(b, 'color'),
        etiqueta: prop(b, 'etiqueta'),
        hasta: prop(b, 'hasta'),
      }))
    },

    altoGrafica() {
      return Math.max(360, this.maquinasFiltradas.length * 88 + 80)
    },

    // Todas las máquinas en producción que reporta /ReportesMoldes/MaquinasActivas, sin
    // restringir al tablero. Se ordenan según la posición de la máquina en la gráfica
    // (por nombre, sin distinción de mayúsculas/espacios) y las que no figuran en el
    // tablero quedan al final, pero ninguna se descarta.
    maquinasActivasFiltradas() {
      const orden = new Map()
      this.maquinasFiltradas.forEach((m, i) => {
        const nombre = String(prop(m, 'nombreMaquina') || '').trim().toUpperCase()
        if (nombre && !orden.has(nombre)) orden.set(nombre, i)
      })
      const pos = (m) => {
        const i = orden.get(String(prop(m, 'maquina') || '').trim().toUpperCase())
        return i === undefined ? Number.MAX_SAFE_INTEGER : i
      }
      return (this.maquinasActivasApi || []).slice().sort((a, b) => pos(a) - pos(b))
    },

    // KPI "Máquinas activas": activas = máquinas en producción (ya restringidas a los filtros);
    // total = instancias que, según el plan, deberían tener una ODT abierta ahora. Este
    // denominador lo calcula el backend (maquinasDebenProducir): máquinas cuyo plan teórico
    // cruza la línea de "ahora".
    maquinasActivas() {
      const total = Number(prop(this.tablero, 'maquinasDebenProducir') || 0)
      return { activas: this.maquinasActivasFiltradas.length, total }
    },

    // Detalle del KPI: máquinas en producción reportadas por el endpoint (ya filtradas) y su
    // número de tokens (cavidades) activos.
    instanciasActivas() {
      return this.maquinasActivasFiltradas.map((m) => {
        const tokens = prop(m, 'tokens') || []
        return {
          maquina: prop(m, 'maquina') || '—',
          detalle: `${tokens.length} ${this.$t('Reports.ProductionPlan.detail.cavities')}`,
        }
      })
    },

    // Máquinas que el plan espera produciendo "ahora": las que tienen un fragmento teórico
    // cuyo rango cruza la fecha de consulta (inicio <= ahora < fin). Es el mismo criterio que
    // usa el backend para maquinasDebenProducir, por eso la cuenta coincide con el denominador.
    maquinasEsperadas() {
      const ahora = toMs(prop(this.tablero, 'fechaConsulta')) || Date.now()
      const lista = []
      this.maquinasFiltradas.forEach((m) => {
        const enCurso = (prop(m, 'barrasTeoricas') || []).find((b) => {
          const ini = toMs(prop(b, 'inicio'))
          const fin = toMs(prop(b, 'fin'))
          return !Number.isNaN(ini) && !Number.isNaN(fin) && ahora >= ini && ahora < fin
        })
        if (!enCurso) return
        lista.push({
          maquina: prop(m, 'nombreMaquina') || prop(m, 'modeloMaquina') || `#${prop(m, 'idMaquina')}`,
          detalle: prop(enCurso, 'clave') || prop(enCurso, 'molde') || '—',
        })
      })
      return lista
    },

    restanteTexto() {
      const s = Math.max(0, this.restante)
      const m = Math.floor(s / 60)
      return `${m}:${String(s % 60).padStart(2, '0')}`
    },

    // Opciones del selector de molde destino (cambio de instancia).
    opcionesMolde() {
      return (this.destinos || []).map((d) => ({
        value: prop(d, 'idMolde'),
        text: `${prop(d, 'codigoMolde') || 'Molde'} · ${prop(d, 'modeloMaquina') || ''}`.trim(),
      }))
    },

    // Instancias del molde destino seleccionado.
    opcionesInstancia() {
      const d = (this.destinos || []).find((x) => prop(x, 'idMolde') === this.destinoMoldeSel)
      if (!d) return []
      return (prop(d, 'instancias') || []).map((i) => {
        const tk = Number(prop(i, 'tokensFisicos') || 0)
        const nombre = prop(i, 'nombre') || `#${prop(i, 'idMaquinaIns')}`
        return {
          value: prop(i, 'idMaquinaIns'),
          // text: tk > 0 ? `${nombre} · ${tk} token(s)` : nombre,
          text: tk > 0 ? `${nombre}` : nombre,
        }
      })
    },

    // Habilita el guardado del nuevo TC: todas las filas con un TC entero positivo.
    tcValido() {
      return this.tcOperaciones.length > 0 &&
        this.tcOperaciones.every((o) => Number(o.tc) > 0)
    },

    // Etiqueta del tipo de fragmento (real ajustado vs plan teórico), reactiva al idioma.
    tipoLabel() {
      if (this.fragmento.esReal == null) return ''
      return this.fragmento.esReal
        ? this.$t('Reports.ProductionPlan.detail.realAdjusted')
        : this.$t('Reports.ProductionPlan.detail.theoreticalPlan')
    },

    // Texto de la banda de desfase. Usa la etiqueta configurable que manda el backend;
    // si no hay (datos antiguos), cae al texto i18n por clave.
    bandaLabel() {
      if (this.fragmento.bandaEtiqueta) return this.fragmento.bandaEtiqueta
      const map = { verde: 'onTarget', amarillo: 'off1to10', naranja: 'off10to15', rojo: 'offOver15' }
      const k = map[this.fragmento.bandaKey]
      return k ? this.$t('Reports.ProductionPlan.band.' + k) : ''
    },

    // Desfase de TIEMPO (real vs teórico) en porcentaje, calculado por el backend.
    desfasePctTexto() {
      const pct = Number(this.fragmento.desfasePct || 0)
      return pct <= 0 ? this.$t('Reports.ProductionPlan.band.onTarget') : `${pct.toFixed(1)}%`
    },

    // Desfase de TIEMPO expresado como duración (cuánto tardó de más respecto al plan).
    desfaseTiempo() {
      const seg = Number(this.fragmento.desfaseSeg || 0)
      return seg <= 0 ? this.$t('Reports.ProductionPlan.band.onTarget') : fmtDuracion(seg)
    },

    datos() {
      const maquinas = this.maquinasFiltradas
      const etiquetas = maquinas.map((m) => prop(m, 'nombreMaquina') || prop(m, 'modeloMaquina') || `#${prop(m, 'idMaquina')}`)

      const meta = {}
      maquinas.forEach((m, i) => {
        meta[etiquetas[i]] = {
          molde: prop(m, 'molde'),
          avanceSeg: Number(prop(m, 'segundosAvance') || 0),
          faltanteSeg: Number(prop(m, 'segundosFaltante') || 0),
          tcProgramado: prop(m, 'tcProgramado'),
          tcReal: prop(m, 'tcReal'),
          tcEsperado: prop(m, 'tcEsperado'),
        }
      })

      const plan = []
      const real = []
      let minMs = Infinity
      let maxMs = -Infinity

      maquinas.forEach((m, idx) => {
        const barrasPlan = prop(m, 'barrasTeoricas') || []
        const barrasReal = prop(m, 'barrasReales') || []

        barrasPlan.forEach((b) => {
          const ini = toMs(prop(b, 'inicio'))
          const fin = toMs(prop(b, 'fin'))
          if (Number.isNaN(ini) || Number.isNaN(fin) || fin <= ini) return
          minMs = Math.min(minMs, ini)
          maxMs = Math.max(maxMs, fin)
          plan.push({
            value: [
              idx,
              ini,
              fin,
              prop(b, 'clave') || '',
              Number(prop(b, 'piezasObjetivo') || 0),
              prop(b, 'molde') || '',
            ],
            raw: b,
          })
        })

        if (this.vista === 'tiempoReal') {
          barrasReal.forEach((b) => {
            const ini = toMs(prop(b, 'inicio'))
            const fin = toMs(prop(b, 'fin'))
            if (Number.isNaN(ini) || Number.isNaN(fin) || fin <= ini) return
            minMs = Math.min(minMs, ini)
            maxMs = Math.max(maxMs, fin)
            const ok = Number(prop(b, 'piezasOk') || 0)
            const obj = Number(prop(b, 'piezasObjetivo') || 0)
            real.push({
              value: [
                idx,
                ini,
                fin,
                prop(b, 'clave') || '',
                ok,
                obj,
                colorBanda(ok, obj, prop(b, 'color')),
                prop(b, 'enCurso') ? 1 : 0,
                prop(b, 'molde') || '',
              ],
              raw: b,
            })
          })
        }
      })

      if (!Number.isFinite(minMs) || !Number.isFinite(maxMs)) {
        const ahora = Date.now()
        minMs = ahora - 12 * 3600 * 1000
        maxMs = ahora + 12 * 3600 * 1000
      }

      const margen = 60 * 60 * 1000
      return {
        etiquetas,
        meta,
        plan,
        real,
        min: minMs - margen,
        max: maxMs + margen,
        finJornada: toMs(prop(this.tablero, 'fechaFinJornada')),
      }
    },
  },

  watch: {
    active(val) {
      if (val) {
        if (!this.tablero) this.cargar()
        else this.$nextTick(() => this.render())
        this.iniciarAutoActualizacion()
      } else {
        this.detenerAutoActualizacion()
      }
    },
    vista() {
      this.render()
    },
    // Al cambiar de idioma, el canvas de echarts no es reactivo: hay que repintarlo
    // para que días/meses y las etiquetas "Ahora"/"Fin Jornada" tomen el nuevo locale.
    currentLocale() {
      this.render()
    },
  },

  async mounted() {
    this.resizeHandler = () => this.chart && this.chart.resize()
    window.addEventListener('resize', this.resizeHandler)
    this.fsHandler = () => this.syncFullscreen()
    document.addEventListener('fullscreenchange', this.fsHandler)
    document.addEventListener('webkitfullscreenchange', this.fsHandler)
    // Ajusta el rango por defecto con los horarios activos antes de la primera carga.
    await this.inicializarDesdeHorarios()
    if (this.active || !this.tablero) this.cargar()
    if (this.active) this.iniciarAutoActualizacion()
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler)
    document.removeEventListener('fullscreenchange', this.fsHandler)
    document.removeEventListener('webkitfullscreenchange', this.fsHandler)
    this.detenerAutoActualizacion()
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },

  methods: {
    fmtNum,

    setLocale(locale) {
      if (!locale) return
      this.$i18n.locale = locale
      localStorage.setItem('locale', locale)
    },

    // Pantalla completa de todo el reporte (la tarjeta raíz).
    toggleFullscreen() {
      const root = this.$refs.fullscreenRoot
      const el = root && root.$el ? root.$el : root
      if (!el) return
      const doc = document
      const enFs = doc.fullscreenElement || doc.webkitFullscreenElement
      if (!enFs) {
        if (el.requestFullscreen) el.requestFullscreen()
        else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen()
      } else {
        if (doc.exitFullscreen) doc.exitFullscreen()
        else if (doc.webkitExitFullscreen) doc.webkitExitFullscreen()
      }
    },

    syncFullscreen() {
      const doc = document
      const fsEl = doc.fullscreenElement || doc.webkitFullscreenElement
      const root = this.$refs.fullscreenRoot
      const el = root && root.$el ? root.$el : root
      this.esFullscreen = !!fsEl && fsEl === el
      // El cambio de pantalla completa no dispara resize de window: re-ajustar la gráfica.
      this.$nextTick(() => this.chart && this.chart.resize())
    },

    colorPorcentaje(p) {
      if (p >= 90) return '#2e9e5b'
      if (p >= 70) return '#e0a83d'
      return '#d64545'
    },

    // Lunes (00:00) de la semana en curso.
    lunesSemanaActual() {
      const hoy = new Date()
      const diff = (hoy.getDay() + 6) % 7 // lunes = 0
      const lunes = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate())
      lunes.setDate(lunes.getDate() - diff)
      return lunes
    },

    // Formatea una fecha al formato del picker: "YYYY-MM-DD HH:mm".
    fmtFiltro(d) {
      const p = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
    },

    // Convierte el valor del picker ("YYYY-MM-DD HH:mm" o "YYYY-MM-DD") a ISO para el query.
    filtroAIso(v) {
      if (!v) return v
      const s = String(v).trim().replace(' ', 'T')
      if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return `${s}T00:00:00`
      if (/T\d{2}:\d{2}$/.test(s)) return `${s}:00`
      return s
    },

    // Fallback síncrono: semana en curso (lunes 00:00 → lunes siguiente 00:00).
    inicializarSemana() {
      const inicio = this.lunesSemanaActual()
      const fin = new Date(inicio)
      fin.setDate(inicio.getDate() + 7)
      this.filtros.inicio = this.fmtFiltro(inicio)
      this.filtros.fin = this.fmtFiltro(fin)
    },

    // Calcula el rango por defecto a partir de los horarios activos (CAT_Horarios):
    // toma el día con menor diaSemana (0=domingo … 6=sábado) y su hora de inicio,
    // ubicándolo en su última ocurrencia en o antes de hoy; el fin es ese mismo
    // punto una semana después.
    async inicializarDesdeHorarios() {
      try {
        // /Horarios responde { events, start, intervals }: los horarios están en events.
        const { data } = await axios.get('/Horarios')
        const horarios = Array.isArray(data)
          ? data
          : Array.isArray(data && data.events)
            ? data.events
            : []
        if (!horarios.length) {
          this.inicializarSemana()
          return
        }

        const menor = horarios.reduce((min, h) =>
          Number(prop(h, 'diaSemana')) < Number(prop(min, 'diaSemana')) ? h : min,
        )
        const diaSemana = Number(prop(menor, 'diaSemana'))
        const [hh, mm] = String(prop(menor, 'inicio') || '00:00').split(':').map(Number)

        // Última ocurrencia de ese día de la semana en o antes de hoy
        // (0=domingo … 6=sábado), p. ej. domingo → el último domingo desde hoy.
        const hoy = new Date()
        const inicio = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate())
        const diff = (inicio.getDay() - diaSemana + 7) % 7
        inicio.setDate(inicio.getDate() - diff)
        inicio.setHours(hh || 0, mm || 0, 0, 0)

        const fin = new Date(inicio)
        fin.setDate(inicio.getDate() + 7)

        this.filtros.inicio = this.fmtFiltro(inicio)
        this.filtros.fin = this.fmtFiltro(fin)
      } catch (e) {
        // Si falla, se usa el fallback de la semana en curso.
        this.inicializarSemana()
        // eslint-disable-next-line no-console
        console.error('Error cargando horarios para fechas por defecto', e)
      }
    },

    // Convierte el catálogo del backend (camel/Pascal) a items {text, value} para v-autocomplete.
    catalogoItems(clave) {
      const cat = prop(this.tablero, 'catalogos') || {}
      const lista = prop(cat, clave) || []
      return lista.map((it) => ({ text: prop(it, 'nombre'), value: prop(it, 'id') }))
    },

    // Reinicia la cuenta regresiva a su valor completo (5 min).
    reiniciarContador() {
      this.restante = this.intervaloSeg
    },

    // Tick de 1 s: descuenta el contador y dispara la recarga al llegar a 0.
    // No descuenta mientras hay una carga en curso para no encimar peticiones.
    iniciarAutoActualizacion() {
      this.detenerAutoActualizacion()
      this.reiniciarContador()
      this.timerTick = setInterval(() => {
        if (this.cargando) return
        if (this.restante <= 1) this.cargar()
        else this.restante -= 1
      }, 1000)
    },

    detenerAutoActualizacion() {
      if (this.timerTick) {
        clearInterval(this.timerTick)
        this.timerTick = null
      }
    },

    async cargar() {
      // Toda recarga (manual o automática) reinicia el contador.
      this.reiniciarContador()
      // Cada recarga refresca las preferencias del reporte (las crea si no existen).
      this.cargarPreferencias()
      this.cargando = true
      this.error = false
      try {
        const p = new URLSearchParams()
        if (this.filtros.inicio) p.append('inicio', this.filtroAIso(this.filtros.inicio))
        if (this.filtros.fin) p.append('fin', this.filtroAIso(this.filtros.fin))
          ; (this.filtros.idsArea || []).forEach((v) => p.append('idsArea', v))
          ; (this.filtros.idsTrabajoOrden || []).forEach((v) => p.append('idsTrabajoOrden', v))
          ; (this.filtros.idsInstancia || []).forEach((v) => p.append('idsInstancia', v))

        const { data } = await axios.get(`/ReportesMoldes/TableroProduccionV4?${p.toString()}`)
        this.tablero = data
        this.$nextTick(() => this.render())
      } catch (e) {
        this.error = true
        // eslint-disable-next-line no-console
        console.error('Error cargando tablero de producción', e)
      } finally {
        this.cargando = false
      }
      // Las máquinas activas son tiempo real (no dependen de los filtros del tablero).
      this.cargarMaquinasActivas()
    },

    // Carga las máquinas en producción (KPI azul). Independiente del tablero: si falla,
    // se conserva el último valor conocido sin marcar el tablero como erróneo.
    async cargarMaquinasActivas() {
      try {
        const { data } = await axios.get('/ReportesMoldes/MaquinasActivas')
        this.maquinasActivasApi = Array.isArray(data) ? data : []
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Error cargando máquinas activas', e)
      }
    },

    // Abre el selector de cambio de instancia y carga los moldes/instancias destino válidos.
    async abrirCambioInstancia() {
      this.cambioError = ''
      this.destinos = []
      this.destinoMoldeSel = null
      this.destinoInstanciaSel = null
      this.dialogCambio = true
      this.cambioCargando = true
      try {
        const { data } = await axios.get(
          `/TrabajoOrdenes/DestinosCambioInstancia/${this.fragmento.idTrabajoOrden}`,
        )
        this.destinos = Array.isArray(data) ? data : []
      } catch (e) {
        this.cambioError = this.$t('Reports.ProductionPlan.errors.loadDestinations')
        // eslint-disable-next-line no-console
        console.error('Error cargando destinos de cambio de instancia', e)
      } finally {
        this.cambioCargando = false
      }
    },

    // Ejecuta el cambio (PUT) y recarga el tablero para reflejar la nueva instancia.
    async confirmarCambioInstancia() {
      if (!this.fragmento.idTrabajoOrden || !this.destinoMoldeSel || !this.destinoInstanciaSel) return
      this.cambioGuardando = true
      this.cambioError = ''
      try {
        await axios.put(
          `/TrabajoOrdenes/CambiarRecetasInicialesOTPorMolde/${this.fragmento.idTrabajoOrden}/${this.destinoMoldeSel}`,
          null,
          { params: { idMaquinaIns: this.destinoInstanciaSel } },
        )
        this.dialogCambio = false
        this.dialogFragmento = false
        await this.cargar()
      } catch (e) {
        const status = e && e.response && e.response.status
        this.cambioError =
          status === 409
            ? this.$t('Reports.ProductionPlan.errors.moveConflict')
            : this.$t('Reports.ProductionPlan.errors.moveFailed')
        // eslint-disable-next-line no-console
        console.error('Error en cambio de instancia', e)
      } finally {
        this.cambioGuardando = false
      }
    },

    // Abre el diálogo de confirmación para terminar anticipadamente la ODT.
    abrirFinalizarOdt() {
      this.finalizarError = ''
      this.dialogFinalizar = true
    },

    // Termina anticipadamente la ODT (PUT) y recarga el tablero.
    async confirmarFinalizarOdt() {
      if (!this.fragmento.idTrabajoOrden) return
      this.finalizarGuardando = true
      this.finalizarError = ''
      try {
        await axios.put(
          `/TrabajoOrdenes/TerminarAnticipadamenteOT/${this.fragmento.idTrabajoOrden}`,
          {},
        )
        this.dialogFinalizar = false
        this.dialogFragmento = false
        await this.cargar()
      } catch (e) {
        this.finalizarError = this.$t('Reports.ProductionPlan.errors.finishFailed')
        // eslint-disable-next-line no-console
        console.error('Error finalizando ODT anticipadamente', e)
      } finally {
        this.finalizarGuardando = false
      }
    },

    // Abre el diálogo para actualizar el TC, precargando el TC actual de cada operación.
    abrirActualizarTc() {
      this.tcError = ''
      this.tcOperaciones = (this.fragmento.operaciones || []).map((o) => ({
        idOperacion: o.idOperacion,
        codigo: o.codigo,
        tcActual: Number(o.tc || 0),
        tc: Number(o.tc || 0),
      }))
      this.dialogTc = true
    },

    // Envía el nuevo TC por operación (PUT) y recarga el tablero. El backend aplica el TC
    // igual que OtsServiceV4 (TiempoMin/Max y TiempoTotalMin/Max).
    async confirmarActualizarTc() {
      if (!this.fragmento.idTrabajoOrden || !this.tcValido) return
      this.tcGuardando = true
      this.tcError = ''
      try {
        const payload = this.tcOperaciones
          .filter((o) => o.idOperacion && Number(o.tc) > 0)
          .map((o) => ({ idOperacion: o.idOperacion, tc: Math.round(Number(o.tc)) }))
        await axios.put(
          `/TrabajoOrdenes/ActualizarTiemposCicloOT/${this.fragmento.idTrabajoOrden}`,
          payload,
        )
        this.dialogTc = false
        this.dialogFragmento = false
        await this.cargar()
      } catch (e) {
        this.tcError = this.$t('Reports.ProductionPlan.errors.updateTcFailed')
        // eslint-disable-next-line no-console
        console.error('Error actualizando TC de la ODT', e)
      } finally {
        this.tcGuardando = false
      }
    },

    // ===================== CONFIGURACIÓN DEL REPORTE (holgura + bandas) =====================
    // Normaliza el objeto de configuración, asegurando tipos y rellenando faltantes.
    normalizarConfig(cfg = {}) {
      const source = cfg && typeof cfg === 'object' ? cfg : {}
      const def = getDefaultConfigReporte()
      let holgura = Number(source.porcentajeHolgura)
      if (!Number.isFinite(holgura)) holgura = def.porcentajeHolgura
      holgura = Math.min(100, Math.max(0, holgura))
      let intervalo = Number(source.intervaloSeg)
      if (!Number.isFinite(intervalo)) intervalo = def.intervaloSeg
      intervalo = Math.round(Math.min(INTERVALO_MAX_SEG, Math.max(INTERVALO_MIN_SEG, intervalo)))
      return {
        porcentajeHolgura: holgura,
        bandasDesfase: this.normalizarBandas(source.bandasDesfase),
        intervaloSeg: intervalo,
      }
    },

    // Normaliza la lista de bandas de desfase: cada banda { hasta (número|null), color (#hex),
    // etiqueta }. Descarta entradas sin color, ordena ascendente por "hasta" (null al final) y
    // fuerza la última banda como catch-all (hasta = null). Si no hay bandas válidas, usa el default.
    normalizarBandas(bandas) {
      const lista = Array.isArray(bandas) ? bandas : []
      const limpias = lista
        .filter((b) => b && typeof b === 'object' && typeof b.color === 'string' && b.color.trim())
        .map((b) => {
          // OJO: Number(null) y Number('') devuelven 0 (no NaN), así que hay que tratar
          // null/undefined/'' como catch-all (hasta = null) ANTES de convertir a número.
          let hasta = null
          if (b.hasta !== null && b.hasta !== undefined && b.hasta !== '') {
            const n = Number(b.hasta)
            hasta = Number.isFinite(n) ? n : null
          }
          let color = String(b.color).trim()
          // El color-picker (modo hexa) puede devolver 8 dígitos (#rrggbbaa); echarts espera 6.
          if (/^#[0-9a-fA-F]{8}$/.test(color)) color = color.slice(0, 7)
          return {
            hasta,
            color,
            etiqueta: typeof b.etiqueta === 'string' ? b.etiqueta : '',
          }
        })
      if (!limpias.length) return getBandasDesfaseDefault()
      limpias.sort((a, b) => {
        if (a.hasta == null) return 1
        if (b.hasta == null) return -1
        return a.hasta - b.hasta
      })
      // La última banda siempre es el catch-all (sin límite superior).
      limpias[limpias.length - 1].hasta = null
      return limpias
    },

    // Desempaqueta la preferencia: puede venir como string JSON, como { configJson } (camel
    // o Pascal) o como el objeto de configuración directo.
    extraerConfig(pref = null) {
      if (!pref) return {}
      if (typeof pref === 'string') {
        try { return JSON.parse(pref) } catch (e) { return {} }
      }
      if (typeof pref !== 'object') return {}

      const rawConfigJson = pref.configJson ?? pref.ConfigJson
      if (rawConfigJson != null) {
        if (typeof rawConfigJson === 'string') {
          try { return JSON.parse(rawConfigJson) } catch (e) { return {} }
        }
        if (typeof rawConfigJson === 'object') return rawConfigJson
      }
      return pref
    },

    guardarConfigLocal(cfg) {
      const normalizada = this.normalizarConfig(this.extraerConfig(cfg))
      localStorage.setItem(this.codigoReporte, JSON.stringify(normalizada))
    },

    recuperarConfigLocal() {
      try {
        const data = localStorage.getItem(this.codigoReporte)
        if (!data) return this.normalizarConfig()
        return this.normalizarConfig(this.extraerConfig(JSON.parse(data)))
      } catch (e) {
        return this.normalizarConfig()
      }
    },

    // Carga las preferencias desde el backend. Si no existen (404), crea las default y las
    // persiste. Se invoca en cada recarga del reporte; mientras el diálogo está abierto no
    // sobrescribe el estado para no pisar lo que el usuario está editando.
    async cargarPreferencias() {
      if (this.dialogConfig) return
      try {
        const { data } = await axios.get(`ReportesConfig/Obtener/${this.codigoReporte}`)
        const pref = this.normalizarConfig(this.extraerConfig(data))
        this.configReporte = { ...pref }
        this.guardarConfigLocal(pref)
      } catch (e) {
        const def = this.normalizarConfig()
        this.configReporte = { ...def }
        this.guardarConfigLocal(def)
        // No existían preferencias: las creamos con el default.
        this.persistirPreferencias(def)
      }
    },

    // POST de la configuración al backend (ReportesConfig/Guardar).
    async persistirPreferencias(cfg) {
      const pref = this.normalizarConfig(this.extraerConfig(cfg))
      this.configGuardando = true
      try {
        await axios.post('ReportesConfig/Guardar/', {
          codigoReporte: this.codigoReporte,
          configJson: JSON.stringify(pref),
        })
        this.configReporte = { ...pref }
        this.guardarConfigLocal(pref)
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Error guardando configuración del reporte', e)
      } finally {
        this.configGuardando = false
      }
    },

    // Texto de rango para la leyenda cuando la banda no tiene etiqueta propia.
    rangoBandaLeyenda(i) {
      const bandas = this.bandasLeyenda
      const desde = i === 0 ? 0 : (Number(bandas[i - 1].hasta) || 0)
      const hasta = bandas[i].hasta
      return hasta == null ? `>${desde}% desfase` : `${desde}%–${hasta}% desfase`
    },

    // Texto legible del rango de la banda i para el encabezado de su tarjeta.
    bandaRangoTexto(i) {
      const bandas = this.configReporte.bandasDesfase
      const desde = this.bandaDesde(i)
      const b = bandas[i]
      if (i === bandas.length - 1 || b.hasta == null || b.hasta === '') {
        return `Desfase de ${desde}% en adelante`
      }
      return `Desfase de ${desde}% a ${b.hasta}%`
    },

    // Límite inferior (en %) de la banda i: 0 para la primera, el "hasta" de la anterior para el resto.
    bandaDesde(i) {
      if (i <= 0) return 0
      const prev = this.configReporte.bandasDesfase[i - 1]
      const h = Number(prev && prev.hasta)
      return Number.isFinite(h) ? h : 0
    },

    // Agrega una banda nueva (catch-all) y convierte la anterior última en banda con límite.
    agregarBanda() {
      const bandas = this.configReporte.bandasDesfase
      const ult = bandas[bandas.length - 1]
      const prevHasta = bandas.length >= 2 ? Number(bandas[bandas.length - 2].hasta) : 0
      // La que era catch-all toma un límite (su 'desde' + 5) para dejar hueco a la nueva.
      if (ult) ult.hasta = (Number.isFinite(prevHasta) ? prevHasta : 0) + 5
      bandas.push({ hasta: null, color: '#d64545', etiqueta: '' })
    },

    quitarBanda(i) {
      const bandas = this.configReporte.bandasDesfase
      if (bandas.length <= 1) return
      bandas.splice(i, 1)
      // La última banda siempre es catch-all (sin límite superior).
      bandas[bandas.length - 1].hasta = null
    },

    abrirConfig() {
      this.configReporte = { ...this.recuperarConfigLocal() }
      this.dialogConfig = true
    },

    cerrarConfig() {
      this.configReporte = { ...this.recuperarConfigLocal() }
      this.dialogConfig = false
    },

    async guardarConfig() {
      await this.persistirPreferencias(this.configReporte)
      // El nuevo intervalo se aplica de inmediato reiniciando la cuenta regresiva.
      if (this.active && this.timerTick) this.reiniciarContador()
      if (!this.configGuardando) this.dialogConfig = false
    },

    async reestablecerConfig() {
      await this.persistirPreferencias(getDefaultConfigReporte())
    },

    render() {
      if (!this.tablero) return
      const el = this.$refs.grafica
      if (!el) return
      if (!this.chart) this.chart = echarts.init(el)
      this.chart.setOption(this.crearOption(this.datos), true)
      this.chart.off('click')
      this.chart.on('click', this.onClickFragmento)
      this.$nextTick(() => this.chart && this.chart.resize())
    },

    crearOption(datos) {
      const ahora = Date.now()
      const mostrarAhora = ahora >= datos.min && ahora <= datos.max
      const mostrarFin = Number.isFinite(datos.finJornada)
      const locale = this.$i18n.locale
      const tNow = this.$t('Reports.ProductionPlan.chart.now')
      const tEndShift = this.$t('Reports.ProductionPlan.chart.endShift')

      return {
        backgroundColor: '#fff',
        animation: false,

        tooltip: {
          trigger: 'item',
          borderColor: '#e6e9ed',
          formatter: (params) => {
            const v = params.value || []
            const esReal = params.seriesName === 'Real'
            const molde = esReal ? v[8] : v[5]
            const lineas = [
              `<b>${params.seriesName === 'Real' ? 'Real ajustado' : 'Plan programado'}</b>`,
              `Máquina: ${datos.etiquetas[v[0]]}`,
              `Molde: ${molde || '—'}`,
              `ODT: ${v[3]}`,
              `Inicio: ${fmtFechaHora(v[1], locale)}`,
              `Fin: ${fmtFechaHora(v[2], locale)}`,
            ]
            if (esReal) {
              const ok = Number(v[4] || 0)
              const obj = Number(v[5] || 0)
              const raw = (params.data && params.data.raw) || {}
              // Desfase de TIEMPO (real vs teórico) calculado en el backend.
              const desfaseSeg = Number(prop(raw, 'desfaseSegundos') || 0)
              const desfasePct = Number(prop(raw, 'desfasePorcentaje') || 0)
              const tiempo = desfaseSeg > 0 ? fmtDuracion(desfaseSeg) : 'En meta'
              const color = v[6]
              const banda = prop(raw, 'bandaEtiqueta') || bandaTexto(ok, obj, prop(raw, 'color'))
              // Tiempo real transcurrido (geometría de la barra) vs tiempo teórico de la ODT.
              const durRealSeg = Math.max(0, Math.round((v[2] - v[1]) / 1000))
              const durTeoSeg = Number(prop(raw, 'duracionTeoricaSegundos') || 0)
              lineas.push(`Tiempo real: ${fmtDuracion(durRealSeg)}`)
              if (durTeoSeg > 0) lineas.push(`Tiempo programado: ${fmtDuracion(durTeoSeg)}`)
              lineas.push(`Piezas: ${fmtNum(ok)} / ${fmtNum(obj)}`)
              lineas.push(`Desfase: ${desfasePct.toFixed(1)}% (${tiempo})`)
              lineas.push(
                `<span style="display:inline-block;width:10px;height:10px;border-radius:2px;` +
                `background:${color};margin-right:5px;vertical-align:middle"></span>${banda}`
              )
            } else {
              lineas.push(`Objetivo: ${fmtNum(v[4])} pzas`)
              // Holgura inyectada al plan teórico (colchón de tiempo extra), si aplica.
              const rawPlan = (params.data && params.data.raw) || {}
              const holguraSeg = Number(prop(rawPlan, 'holguraSegundos') || 0)
              if (holguraSeg > 0) {
                lineas.push(`${this.$t('Reports.ProductionPlan.detail.slack')}: +${fmtDuracion(holguraSeg)}`)
              }
            }
            return lineas.join('<br/>')
          },
        },

        grid: { left: 188, right: 28, top: 44, bottom: 58 },

        dataZoom: [
          { type: 'inside', xAxisIndex: 0, filterMode: 'none' },
          { type: 'slider', xAxisIndex: 0, height: 20, bottom: 20, filterMode: 'none' },
        ],

        xAxis: {
          type: 'time',
          position: 'top',
          min: datos.min,
          max: datos.max,
          axisLabel: {
            color: '#283139',
            fontWeight: 700,
            formatter: (value) => {
              const d = new Date(value)
              if (d.getHours() === 0 && d.getMinutes() === 0) {
                const dias = DIAS[locale] || DIAS.es
                const meses = MESES[locale] || MESES.es
                return `{dia|${dias[d.getDay()]} ${d.getDate()} ${meses[d.getMonth()]}}`
              }
              return `${String(d.getHours()).padStart(2, '0')}:00`
            },
            rich: { dia: { fontWeight: 800, fontSize: 13, color: '#283139' } },
          },
          splitLine: { show: true, lineStyle: { color: '#e6e9ed' } },
          axisLine: { lineStyle: { color: '#bdbdbd' } },
        },

        yAxis: {
          type: 'category',
          inverse: true,
          data: datos.etiquetas,
          axisTick: { show: false },
          axisLine: { show: false },
          splitLine: { show: false },
          axisLabel: {
            // Ancla a la izquierda: align 'left' + margin grande hace que todas las
            // etiquetas arranquen al mismo x (pegadas al borde izquierdo), sin importar su largo.
            align: 'left',
            margin: 176,
            formatter: (name) => `{nom|${name}}`,
            rich: {
              nom: { color: '#283139', fontSize: 15, fontWeight: 800, align: 'left' },
            },
          },
        },

        series: [
          this.serie('Plan', datos.plan, 1, this.renderPlan),
          this.serie('Real', datos.real, 3, this.renderReal),
          {
            name: 'Ahora',
            type: 'line',
            data: [],
            silent: true,
            markLine: {
              symbol: 'none',
              label: {
                show: mostrarAhora,
                formatter: tNow,
                color: '#fff',
                backgroundColor: COLOR.ahora,
                padding: [3, 7],
                borderRadius: 3,
                fontWeight: 700,
              },
              lineStyle: { color: COLOR.ahora, type: 'dashed', width: 2 },
              data: mostrarAhora ? [{ xAxis: ahora }] : [],
            },
          },
          {
            name: 'Fin Jornada',
            type: 'line',
            data: [],
            silent: true,
            markLine: {
              symbol: 'none',
              label: {
                show: mostrarFin,
                formatter: tEndShift,
                color: '#fff',
                backgroundColor: COLOR.finJornada,
                padding: [3, 7],
                borderRadius: 3,
                fontWeight: 700,
              },
              lineStyle: { color: COLOR.finJornada, type: 'solid', width: 3 },
              data: mostrarFin ? [{ xAxis: datos.finJornada }] : [],
            },
          },
        ],
      }
    },

    serie(nombre, data, z, renderItem) {
      return {
        name: nombre,
        type: 'custom',
        z,
        encode: { x: [1, 2], y: 0 },
        data,
        renderItem,
      }
    },

    // Geometría compartida: teórico de DOBLE altura (arriba), real de altura simple
    // pegada a la parte inferior. El teórico pinta su dato en la mitad superior, que
    // la barra real no cubre.
    geometriaFila(p0, rowH) {
      const gap = rowH * 0.1
      const realH = rowH * 0.3
      const planH = realH * 2
      const bottomY = p0[1] + rowH / 2 - gap
      return { realH, planH, bottomY }
    },

    renderPlan(params, api) {
      const cat = api.value(0)
      const p0 = api.coord([api.value(1), cat])
      const p1 = api.coord([api.value(2), cat])
      const rowH = api.size([0, 1])[1]
      const ancho = p1[0] - p0[0]
      const { planH, realH, bottomY } = this.geometriaFila(p0, rowH)
      const y = bottomY - planH

      const rect = echarts.graphic.clipRectByRect(
        { x: p0[0], y, width: ancho, height: planH },
        { x: params.coordSys.x, y: params.coordSys.y, width: params.coordSys.width, height: params.coordSys.height }
      )
      if (!rect) return null

      const children = [
        {
          type: 'rect',
          shape: { x: rect.x, y: rect.y, width: rect.width, height: rect.height, r: 6 },
          style: { fill: COLOR.planFill, stroke: COLOR.planBorde, lineWidth: 1 },
        },
      ]

      if (ancho > 64) {
        const molde = api.value(5) || api.value(3)
        const texto = `${molde}  ${fmtNum(api.value(4))}`
        // Dato en la mitad SUPERIOR (no la tapa la barra real).
        children.push({
          type: 'text',
          style: {
            x: rect.x + 7,
            y: rect.y + realH / 2,
            text: texto,
            fill: COLOR.planTexto,
            fontSize: 11,
            fontWeight: 700,
            textVerticalAlign: 'middle',
            width: rect.width - 12,
            overflow: 'truncate',
          },
        })
      }

      return { type: 'group', children }
    },

    renderReal(params, api) {
      const cat = api.value(0)
      const p0 = api.coord([api.value(1), cat])
      const p1 = api.coord([api.value(2), cat])
      const rowH = api.size([0, 1])[1]
      const ancho = p1[0] - p0[0]
      const { realH, bottomY } = this.geometriaFila(p0, rowH)
      const y = bottomY - realH // pegada a la parte inferior

      const rect = echarts.graphic.clipRectByRect(
        { x: p0[0], y, width: ancho, height: realH },
        { x: params.coordSys.x, y: params.coordSys.y, width: params.coordSys.width, height: params.coordSys.height }
      )
      if (!rect) return null

      const color = api.value(6)
      const enCurso = api.value(7) === 1
      const children = []

      // Marco azul para la barra real de la ODT en curso.
      if (enCurso) {
        children.push({
          type: 'rect',
          shape: { x: rect.x - 2.5, y: rect.y - 2.5, width: rect.width + 5, height: rect.height + 5, r: 7 },
          style: { fill: 'transparent', stroke: COLOR.azul, lineWidth: 2.5 },
        })
      }

      children.push({
        type: 'rect',
        shape: { x: rect.x, y: rect.y, width: rect.width, height: rect.height, r: 5 },
        style: { fill: color },
      })

      if (ancho > 58) {
        const badgeW = 52
        const molde = api.value(8) || api.value(3)
        children.push({
          type: 'rect',
          shape: { x: rect.x + 4, y: rect.y + rect.height / 2 - 8, width: badgeW, height: 16, r: 4 },
          style: { fill: 'rgba(255,255,255,0.97)' },
        })
        children.push({
          type: 'text',
          style: {
            x: rect.x + 4 + badgeW / 2,
            y: rect.y + rect.height / 2,
            text: molde,
            fill: '#283139',
            fontSize: 10,
            fontWeight: 800,
            textAlign: 'center',
            textVerticalAlign: 'middle',
            width: badgeW - 6,
            overflow: 'truncate',
          },
        })
        if (ancho > badgeW + 86) {
          children.push({
            type: 'text',
            style: {
              x: rect.x + 4 + badgeW + 7,
              y: rect.y + rect.height / 2,
              text: `${fmtNum(api.value(4))} / ${fmtNum(api.value(5))}`,
              fill: '#fff',
              fontSize: 11,
              fontWeight: 700,
              textVerticalAlign: 'middle',
              width: rect.width - badgeW - 22,
              overflow: 'truncate',
            },
          })
        }
      }

      return { type: 'group', children }
    },

    onClickFragmento(p) {
      if (p.seriesName !== 'Plan' && p.seriesName !== 'Real') return
      const v = p.value || []
      const raw = (p.data && p.data.raw) || {}
      const esReal = p.seriesName === 'Real'

      const objetivo = esReal ? Number(v[5] || 0) : Number(v[4] || 0)
      const ok = esReal ? Number(v[4] || 0) : 0
      const noOk = Number(prop(raw, 'piezasNoOk') || 0)
      const faltantes = Math.max(0, objetivo - ok)
      const cumplimiento = objetivo > 0 ? Math.round((ok / objetivo) * 100) : 0
      const durSeg = Math.max(0, Math.round((v[2] - v[1]) / 1000))
      const tc = Number(prop(raw, 'tc') || 0)
      const tcReal = esReal && ok > 0 && durSeg > 0 ? Math.round(durSeg / ok) : 0
      const colorHex = esReal ? colorBanda(ok, objetivo, prop(raw, 'color')) : COLOR.planFill

      // ODT "no iniciada": marca autoritativa del backend (la ODT no tiene producción real).
      // No se infiere de barrasReales porque el backend agrega un pronóstico real a TODA teórica.
      const idTrabajoOrden = Number(prop(raw, 'idTrabajoOrden') || 0)
      const iniciada = prop(raw, 'iniciada') === true

      this.fragmento = {
        esReal,
        idTrabajoOrden,
        idMolde: Number(prop(raw, 'idMolde') || 0),
        noIniciada: !esReal && idTrabajoOrden > 0 && !iniciada,
        maquina: this.datos.etiquetas[v[0]],
        area: prop(raw, 'area') || '—',
        molde: prop(raw, 'molde') || (esReal ? v[8] : v[5]) || '—',
        clave: prop(raw, 'clave') || v[3] || '—',
        articulo: prop(raw, 'articulo') || '—',
        inicio: fmtFechaHora(v[1], this.$i18n.locale),
        fin: fmtFechaHora(v[2], this.$i18n.locale),
        duracion: fmtDuracion(durSeg),
        // Holgura (solo fragmentos teóricos): colchón de tiempo extra que el backend inyecta al
        // plan. duracionBase = duración sin holgura; holgura = los segundos extra; la "duracion"
        // de arriba ya es el total (base + holgura, según la geometría de la barra).
        holguraSeg: !esReal ? Number(prop(raw, 'holguraSegundos') || 0) : 0,
        holgura: !esReal ? fmtDuracion(Number(prop(raw, 'holguraSegundos') || 0)) : '',
        duracionBase: !esReal ? fmtDuracion(Number(prop(raw, 'duracionTeoricaSegundos') || 0)) : '',
        // Tiempo teórico planificado de la ODT CON HOLGURA (duración base + colchón): es la
        // referencia contra la que el backend mide el desfase. En las barras reales el backend
        // ya lo expone con la holgura incluida; en las teóricas es la propia duración del fragmento.
        duracionTeorica: esReal
          ? (Number(prop(raw, 'duracionTeoricaSegundos') || 0) > 0
              ? fmtDuracion(Number(prop(raw, 'duracionTeoricaSegundos')))
              : null)
          : fmtDuracion(durSeg),
        objetivo,
        ok,
        noOk,
        faltantes,
        cumplimiento,
        cumplimientoBar: Math.min(100, cumplimiento),
        tc: tc || 0,
        tcReal,
        // Desfase de TIEMPO (real vs teórico CON HOLGURA) que envía el backend.
        desfaseSeg: esReal ? Number(prop(raw, 'desfaseSegundos') || 0) : 0,
        desfasePct: esReal ? Number(prop(raw, 'desfasePorcentaje') || 0) : 0,
        enCurso: esReal ? v[7] === 1 : false,
        colorHex,
        bandaKey: esReal ? bandaKey(ok, objetivo, prop(raw, 'color')) : '',
        // Etiqueta de banda configurable que manda el backend (tiene prioridad en bandaLabel).
        bandaEtiqueta: esReal ? (prop(raw, 'bandaEtiqueta') || '') : '',
        // Detalle por operación (cavidad). Plan: solo esperadas; Real: + hechas/ok/noOk.
        operaciones: (prop(raw, 'operaciones') || []).map((o) => ({
          idOperacion: prop(o, 'idOperacion'),
          codigo: prop(o, 'codigo'),
          tc: Number(prop(o, 'tc') || 0),
          esperadas: Number(prop(o, 'cantidad') || 0),
          ok: Number(prop(o, 'piezasOk') || 0),
          noOk: Number(prop(o, 'piezasNoOk') || 0),
          totales: Number(prop(o, 'piezasTotales') || 0),
        })),
      }
      this.dialogFragmento = true
    },
  },
}
</script>

<style scoped>
.board-pp {
  --ink: #283139;
  --muted: #6b7682;
  --line: #e6e9ed;
  --blue: #2563d6;
  background: #fff;
  padding: 16px 18px 22px;
}

/* Pantalla completa: la tarjeta llena la pantalla y permite scroll de todo el contenido */
.board-pp:fullscreen,
.board-pp:-webkit-full-screen {
  background: #fff;
  overflow: auto;
  width: 100vw;
  height: 100vh;
  border-radius: 0 !important;
  box-shadow: none !important;
}

/* El fondo detrás del elemento en pantalla completa (por defecto es negro) */
.board-pp:fullscreen::backdrop {
  background: #fff;
}

.board-pp:-webkit-full-screen::backdrop {
  background: #fff;
}

.pp-fs-btn {
  height: 30px !important;
}

.pp-language-control {
  display: inline-flex;
  align-items: center;
  min-height: 38px;
  padding: 5px 9px;
  border: 1px solid #1976d2;
  border-radius: 6px;
  background: #f8fbff;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.16);
}

.pp-language-toggle {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: none !important;
}

.pp-language-toggle .pp-language-btn.v-btn {
  min-width: 44px !important;
  height: 28px !important;
  border: 1px solid #bbdefb !important;
  color: #1976d2 !important;
  background: #e3f2fd !important;
  font-weight: 700;
  letter-spacing: 0;
  opacity: 1 !important;
}

.pp-language-toggle .pp-language-btn.v-btn:not(.v-btn--active) {
  color: #1565c0 !important;
  background: #e3f2fd !important;
}

.pp-language-toggle .pp-language-btn.v-btn .v-btn__content {
  color: inherit !important;
  opacity: 1 !important;
}

.pp-language-toggle .pp-language-btn--active.v-btn,
.pp-language-toggle .pp-language-btn.v-btn.v-btn--active {
  border-color: #1976d2 !important;
  color: #ffffff !important;
  background: #1976d2 !important;
  box-shadow: none !important;
}

/* Toolbar */
.toolbar {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}

.seg-toggle {
  display: inline-flex;
  background: #eef1f4;
  border-radius: 999px;
  padding: 3px;
}

.seg-toggle button {
  border: 0;
  background: transparent;
  padding: 7px 16px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  color: var(--muted);
  cursor: pointer;
}

.seg-toggle button.act {
  background: var(--blue);
  color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .15);
}

.orden-note {
  font-size: 13px;
  font-weight: 600;
  color: var(--ink);
}

.auto-refresh {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 700;
  color: var(--blue);
  background: #f0f5ff;
  border: 1px solid #d6e2ff;
  border-radius: 999px;
  padding: 5px 12px;
  white-space: nowrap;
}

.auto-refresh .v-icon {
  color: var(--blue);
}

.auto-refresh.is-loading {
  color: var(--muted);
  background: #f1f3f6;
  border-color: var(--line);
}

.auto-refresh .spin {
  animation: pp-spin 1s linear infinite;
}

@keyframes pp-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* Filtros */
.filtros {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px solid var(--line);
  background: #f7f9fc;
  border-radius: 10px;
}

.f-field {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.f-field.f-grow {
  flex: 1;
  min-width: 140px;
}

.f-field label {
  font-size: 11px;
  font-weight: 700;
  color: var(--muted);
  text-transform: uppercase;
  letter-spacing: .03em;
}

.f-field.f-grow {
  min-width: 200px;
}

/* Datepicker: el activador (v-text-field) ocupa el mismo ancho que los selects */
.f-field>>>.v-text-field {
  min-width: 150px;
}

/* Overrides del v-date-picker: el _tables.scss global rompe la tabla del
   calendario (filas/colores). Estas reglas la neutralizan, igual que en
   el componente MenuDatepicker. */
.pp-date-picker>>>.v-btn--rounded {
  border-radius: 28px !important;
}

.pp-date-picker>>>.v-btn.v-btn--disabled {
  color: rgba(0, 0, 0, .26) !important;
}

.pp-date-picker>>>.v-btn {
  color: rgba(0, 0, 0, 0.87) !important;
  font-family: Roboto, sans-serif;
  font-weight: 500 !important;
  padding: 0;
}

.pp-date-picker>>>.v-date-picker-table .v-btn.v-btn--active {
  color: #fff !important;
}

.pp-date-picker>>>.accent {
  background-color: #005caf !important;
  border-color: #005caf !important;
}

.pp-date-picker>>>.accent--text {
  color: #005caf !important;
  caret-color: #005caf !important;
}

.pp-date-picker>>>.v-btn__content {
  font-family: Roboto, sans-serif;
  font-weight: 500 !important;
  flex-grow: 1;
}

.pp-date-picker>>>tbody tr:nth-of-type(odd) {
  background-color: transparent;
}

.pp-date-picker>>>.v-btn--active:before,
.pp-date-picker>>>.v-btn:focus:before,
.pp-date-picker>>>.v-btn:hover:before {
  background-color: rgb(85, 85, 85);
}

.pp-date-picker>>>.v-date-picker-header__value button {
  font-size: 1rem;
}

.f-field>>>.v-input {
  margin: 0;
  padding: 0;
  font-size: 13px;
}

.f-field>>>.v-input__control {
  min-height: 34px;
}

.f-field>>>.v-select__selections {
  min-height: 32px;
}

.f-aplicar {
  align-self: flex-end;
  height: 40px;
}

.tb-right {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 12px;
}

.filter-grp {
  display: flex;
  align-items: center;
  gap: 6px;
}

.fg-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--muted);
}

.chip {
  border: 1px solid var(--line);
  background: #fff;
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 12.5px;
  font-weight: 500;
  color: var(--ink);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

.chip.act {
  border-color: var(--blue);
  color: var(--blue);
  background: #f0f5ff;
  font-weight: 600;
}

.pop {
  background: #fff;
  padding: 8px 12px;
  display: grid;
  gap: 2px;
  max-height: 320px;
  overflow: auto;
}

.pop-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  padding: 3px 0;
  cursor: pointer;
  color: var(--ink);
}

.pop-item.pop-all {
  border-bottom: 1px solid var(--line);
  padding-bottom: 6px;
  margin-bottom: 4px;
  font-weight: 600;
}

/* KPI Máquinas activas (réplica de ReporteCumplimientoProduccion) */
.pp-kpi-grid {
  margin: 0 0 14px;
}

.cp-kpi-grid {
  display: grid;
  align-items: stretch;
  gap: 14px;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
}

.cp-kpi-card {
  background: linear-gradient(180deg, #f8fbff 0%, #f2f6fc 100%);
  border: 1px solid #c4d5ea;
  border-radius: 22px;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
  min-height: 130px;
  padding: 14px 16px 12px;
}

.cp-kpi-card--blue {
  border-color: #8fc1f3;
}

.cp-kpi-top {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.cp-kpi-top-main {
  align-items: center;
  display: flex;
  gap: 12px;
  min-width: 0;
}

.cp-kpi-eye-btn {
  height: 26px !important;
  margin-left: 8px;
  width: 26px !important;
}

.cp-kpi-eye-icon {
  color: #9aa6b8 !important;
  font-size: 1.1rem !important;
}

.cp-kpi-icon-pack {
  align-items: center;
  border-radius: 16px;
  display: inline-flex;
  height: 52px;
  justify-content: center;
  width: 52px;
}

.cp-kpi-icon-pack--blue {
  background: linear-gradient(145deg, #d8e9fb, #c6def7);
}

.cp-kpi-icon-main {
  color: #2e8aed !important;
  font-size: 1.45rem !important;
}

.cp-kpi-title {
  color: #1c2639;
  font-size: clamp(1.05rem, 1.1vw, 1.3rem);
  font-weight: 700;
  line-height: 1.15;
  margin: 0;
  text-align: left;
}

.cp-kpi-value-row {
  align-items: baseline;
  display: flex;
  gap: 8px;
  justify-content: center;
  margin: 8px 0 4px;
  text-align: center;
  width: 100%;
}

.cp-kpi-value-main {
  font-size: 52px !important;
  font-weight: 800;
  line-height: 0.9;
  margin: 0;
}

.cp-kpi-value-main--blue {
  color: #2d84da;
}

.cp-kpi-value-secondary {
  color: #667791;
  font-size: 27px !important;
  font-weight: 700;
  line-height: 1;
  margin: 0;
}

.cp-kpi-caption {
  color: #657993;
  font-size: clamp(0.9rem, 0.95vw, 1rem);
  font-weight: 500;
  line-height: 1.1;
  margin: auto 0 0;
}

/* Leyenda */
.legend {
  display: flex;
  gap: 18px;
  flex-wrap: wrap;
  align-items: center;
  margin: 14px 2px 4px;
}

.lg {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 12.5px;
  color: var(--muted);
}

.lg i {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  display: inline-block;
}

.lg i.i-plan {
  background: #dcf0d6;
  border: 1.5px solid #7cbd74;
}

/* Avance total */
.resumen {
  display: flex;
  align-items: center;
  gap: 14px;
  border: 1px solid var(--line);
  background: #f7f9fc;
  border-radius: 10px;
  padding: 11px 16px;
  margin: 14px 0 10px;
}

.rs-titulo {
  font-size: 13px;
  font-weight: 700;
  color: var(--ink);
  white-space: nowrap;
}

.rs-bar {
  flex: 1;
  height: 8px;
  border-radius: 5px;
  background: #e9edf2;
  overflow: hidden;
  min-width: 120px;
}

.rs-fill {
  height: 100%;
  border-radius: 5px;
  transition: width .3s ease;
}

.rs-pct {
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -.02em;
}

.rs-sub {
  font-size: 12.5px;
  color: var(--muted);
  white-space: nowrap;
}

.cp-empty {
  padding: 40px 4px;
  color: var(--muted);
  font-size: 14px;
  text-align: center;
}

.grafica-tablero {
  width: 100%;
  min-height: 360px;
}

.frag-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--ink);
  display: flex;
  align-items: center;
}

/* Los botones de acciones pueden saltar de línea para no desbordar la carta
   ni generar scroll horizontal cuando hay varias acciones visibles. */
.frag-actions {
  flex-wrap: wrap;
  row-gap: 4px;
}

.frag-actions .v-btn {
  flex: 0 1 auto;
  min-width: 0;
}

.cambio-lbl {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: var(--muted);
  margin: 12px 0 4px;
}

.cambio-error {
  background: #fdecec;
  color: #b42318;
  border: 1px solid #f3c6c2;
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 13px;
  margin-bottom: 8px;
}

/* Editor de bandas de color por desfase (tarjetas) */
.bandas-cards {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.banda-card {
  border: 1px solid #e6e9ed;
  border-radius: 10px;
  background: #fafbfc;
  padding: 10px 12px;
}

.banda-card-top {
  display: flex;
  align-items: center;
  gap: 10px;
}

.banda-swatch {
  flex: 0 0 auto;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.18);
  cursor: pointer;
  display: block;
}

.banda-rango-txt {
  font-weight: 700;
  font-size: 13.5px;
  color: var(--ink, #283139);
}

.banda-card-body {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  margin-top: 10px;
}

.banda-field {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.banda-field--grow {
  flex: 1 1 auto;
}

.banda-field label {
  font-size: 11px;
  font-weight: 600;
  color: #6b7682;
}

.banda-hasta-input {
  max-width: 120px;
}

.banda-ultima {
  flex: 0 0 auto;
  font-size: 12px;
  font-style: italic;
  color: #6b7682;
  padding-bottom: 8px;
}

.frag-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid #f1f3f6;
  font-size: 13.5px;
}

.frag-row:last-child {
  border-bottom: 0;
}

.frag-row span {
  color: var(--muted);
}

.frag-row b {
  color: var(--ink);
  font-weight: 700;
  text-align: right;
}

.frag-dot {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  display: inline-block;
  margin-right: 8px;
}

.frag-banda {
  font-size: 12px;
  font-weight: 700;
}

.frag-rango {
  display: inline-flex;
  align-items: center;
}

.frag-sec {
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: .05em;
  color: #97a0aa;
  margin: 12px 0 2px;
}

.frag-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 18px;
}

.frag-row--wide {
  grid-column: 1 / -1;
}

.frag-progress {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
}

.frag-progress-bar {
  flex: 1;
  height: 8px;
  border-radius: 5px;
  background: #e9edf2;
  overflow: hidden;
}

.frag-progress-fill {
  height: 100%;
  border-radius: 5px;
  transition: width .3s ease;
}

.frag-progress-txt {
  font-size: 12px;
  font-weight: 700;
  color: var(--ink);
  white-space: nowrap;
}

.frag-ops {
  width: 100%;
  border-collapse: collapse;
  margin-top: 4px;
  font-size: 12px;
}

.frag-ops th {
  text-align: left;
  font-weight: 700;
  color: #97a0aa;
  border-bottom: 1px solid var(--line);
  padding: 4px 8px;
  white-space: nowrap;
}

.frag-ops td {
  padding: 5px 8px;
  border-bottom: 1px solid #f1f3f6;
  color: var(--ink);
  font-weight: 600;
}

.frag-ops .num {
  text-align: right;
}

.frag-ops-id {
  color: #b3bcc6;
  font-weight: 600;
  font-size: 10px;
}
</style>

<!-- Popover (montado fuera del scope) -->
<style>
.pp-pop-menu {
  border: 1px solid #e6e9ed;
  border-radius: 10px;
  box-shadow: 0 8px 26px rgba(20, 30, 40, 0.14);
  background: #fff;
}

.pp-pop-menu .pop {
  background: #fff;
  padding: 8px 12px;
  display: grid;
  gap: 2px;
  max-height: 320px;
  overflow: auto;
  min-width: 180px;
}

.pp-pop-menu .pop-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  padding: 3px 0;
  cursor: pointer;
  color: #283139;
}

.pp-pop-menu .pop-item.pop-all {
  border-bottom: 1px solid #e6e9ed;
  padding-bottom: 6px;
  margin-bottom: 4px;
  font-weight: 600;
}

.pp-pop-menu .pop-item input {
  cursor: pointer;
}
</style>
